import { FC } from 'react'
import * as React from 'react'

import { Link } from '../../../../../../helpers/navStructure'
import { FontFamilies, color } from '../../../../../../style/variables'
import { CustomLink } from '../../../../../links'

export interface MobileTier2MenuItemProps {
  label: string
  href: string
  onNavigate: () => void
  childLinks: Link[]
  highlighted: boolean
  highlightedTier3Link: Link | null
}

const MobileTier2MenuItem: FC<MobileTier2MenuItemProps> = ({ label, href, onNavigate, childLinks, highlighted, highlightedTier3Link }) => {
  return (
    <>
      <style jsx>{`
        .nav-item {
          text-decoration: none;
          width: 224px;
          height: 40px;
          font-family: ${FontFamilies.barlow};
          font-size: 13px;
          font-weight: 500;
          font-stretch: normal;
          font-style: normal;
          line-height: 3.08;
          letter-spacing: 1px;
          color: ${highlighted ? color.brandPrimary : color.textStandard};
          text-transform: uppercase;
          display: block;
        }
        .tier3-menu {
          margin-left: 32px;
        }
      `}</style>
      {href.startsWith('/virgin-red') ? (
        <CustomLink to={href}>
          <div className="nav-item" onClick={onNavigate} role="link">
            {label}
          </div>
        </CustomLink>
      ) : (
        <a href={href} className="nav-item" onClick={onNavigate}>
          {label}
        </a>
      )}
      {childLinks.length > 0 && (
        <div className="tier3-menu">
          {childLinks.map((l) => (
            <MobileTier2MenuItem
              key={l.href}
              label={l.label}
              href={l.href}
              childLinks={l.children}
              onNavigate={onNavigate}
              highlighted={l.href === highlightedTier3Link?.href}
              highlightedTier3Link={null}
            />
          ))}
        </div>
      )}
    </>
  )
}

export default MobileTier2MenuItem
